import { useCallback } from "react";
import { useLocalStorage } from "@rehooks/local-storage";

const useDashboardOverviewColumnDismissedAnnouncements = () => {
  const [dismissedAnnouncements, setDismissedAnnouncements] = useLocalStorage<string[]>(
    "dashboardWidgetAnnouncementClosed"
  );

  const isDismissed = useCallback(
    (id: string) => !!dismissedAnnouncements?.includes(id),
    [dismissedAnnouncements]
  );

  const dismiss = useCallback(
    (id: string) =>
      setDismissedAnnouncements(dismissedAnnouncements ? [...dismissedAnnouncements, id] : [id]),
    [dismissedAnnouncements, setDismissedAnnouncements]
  );

  return { isDismissed, dismiss };
};

export default useDashboardOverviewColumnDismissedAnnouncements;
